import Vue from 'vue'
import state from 'lib/appState'

export default el => new Vue({
  el,
  data () {
    return {
      state
    }
  },
  computed: {
    getBreadcrumbsProduct () {
      return this.state.activeProduct
    }
  }
})
